import React from "react";
import styled, { css, keyframes } from "styled-components";

export default function IconWrapper({
  bg = "--light-blue",
  w = 60,
  h = 60,
  icon = "phone",
  iconW = 20,
  iconH = 20,
  iconBg = "--white",
  animation = "",
}) {
  return (
    <StyledIconWrapper
      $bg={bg}
      $w={w}
      $h={h}
      $iconW={iconW}
      $iconH={iconH}
      $iconBg={iconBg}
      $animation={animation}
    >
      {" "}
      <i className={"icon icon-" + icon} />
    </StyledIconWrapper>
  );
}

const phoneBellAnim = keyframes`
  0%, 100%{
    transform: rotate(270deg);
  }

  10% {
    transform: rotate(280deg);
  }
  
  20% {
    transform: rotate(265deg);
  }

  30% {
    transform: rotate(280deg);
  }
  
  40% {
    transform: rotate(265deg);
  }

  50% {
    transform: rotate(280deg);
  }
  
  60% {
    transform: rotate(265deg);
  }
`;

const phoneCircleAnim = keyframes`
  0%, 100%{
    transform: scale(1);
  }

  15% {
    transform: scale(1.15);
  }

  25% {
    transform: scale(1.15);
  }

  70% {
    transform: scale(1);
  }
`;

const StyledIconWrapper = styled.div`
  background-color: var(${(props) => props.$bg});
  width: ${(props) => props.$w}px;
  height: ${(props) => props.$h}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.4s ease;

  i.icon {
    background-color: var(${(props) => props.$iconBg});
    width: ${(props) => props.$iconW}px;
    height: ${(props) => props.$iconH}px;
  }

  ${({ $animation }) =>
    $animation === "nav"
      ? css`
          animation-name: ${phoneCircleAnim};
          animation-duration: 4s;
          animation-iteration-count: infinite;
          animation-timing-function: ease;

          i.icon {
            animation-name: ${phoneBellAnim};
            animation-duration: 2s;
            animation-iteration-count: infinite;
            animation-timing-function: ease;
          }
        `
      : $animation === "scale&&rotate"
      ? css`
          &:hover {
            transform: scale(1.1) rotate(8deg);
          }
        `
      : css`
          &:hover {
            transform: scale(1.125);
          }
        `}
`;
